import * as styles from "./ListSection.css";

import { clsx } from "clsx";
import { useId } from "react";
import type { JSX } from "react";

import { useListContext } from "./List.context";
import type { ListSectionProps } from "./List.types";
import {
  useListVirtualItem,
  virtualItemStyle,
} from "./ListVirtualItem.context";

export function ListSection({
  label,
  sticky = true,
  className,
  style,
  children,
  ...props
}: ListSectionProps): JSX.Element {
  const { size, selectable } = useListContext();

  const virtualItem = useListVirtualItem();

  const labelId = useId();

  const isSticky = sticky && null === virtualItem;

  return (
    <div
      data-slot="list-section"
      data-index={virtualItem?.index}
      ref={virtualItem?.measure}
      role={selectable ? "group" : undefined}
      aria-labelledby={undefined === label ? undefined : labelId}
      className={clsx(styles.section, className)}
      style={{ ...virtualItemStyle(virtualItem), ...style }}
      {...props}
    >
      {undefined !== label && (
        <div
          data-slot="list-section-label"
          id={labelId}
          className={clsx(styles.label({ size }), isSticky && styles.sticky)}
        >
          {label}
        </div>
      )}

      {children}
    </div>
  );
}
